module.exports = __webpack_public_path__ + "static/media/skeleton_wizard_head.4d835f8d.png";